/**
 * Labels e cores de badge para os enums da feature de Carga de pagamentos /
 * liquidações (FXSR-2445). Todos os enums trafegam como string (nome do enum).
 */

export const TIPO_IMPORTACAO_LABELS: { [key: string]: string } = {
  LiquidacaoRecebivel: 'Liquidação de recebível',
}

export const TIPO_ARQUIVO_LABELS: { [key: string]: string } = {
  Xlsx: 'Excel (.xlsx)',
}

// Template (.xlsx) disponível para download por tipo de importação. Para suportar
// um novo tipo, basta adicionar o arquivo em public/templates e mapeá-lo aqui.
export const TIPO_IMPORTACAO_TEMPLATES: { [key: string]: string } = {
  LiquidacaoRecebivel: 'template-importacao-liquidacao.xlsx',
}

export const tipoImportacaoTemplate = (value: string) => TIPO_IMPORTACAO_TEMPLATES[value] || ''

export const ORIGEM_PAGAMENTO_LABELS: { [key: string]: string } = {
  Importacao: 'Importação',
  Integracao: 'Integração',
}

export const STATUS_IMPORTACAO_LABELS: { [key: string]: string } = {
  Recebido: 'Recebido',
  EmProcessamento: 'Em processamento',
  Processado: 'Processado',
  ProcessadoComFalhas: 'Processado com falhas',
  Falha: 'Falha',
  Cancelado: 'Cancelado',
}

export const STATUS_IMPORTACAO_ITEM_LABELS: { [key: string]: string } = {
  Pendente: 'Pendente',
  Valida: 'Válida',
  Invalida: 'Inválida',
  Importada: 'Importada',
  Duplicada: 'Duplicada',
}

export const STATUS_LIQUIDACAO_LABELS: { [key: string]: string } = {
  Solicitado: 'Solicitado',
  Pago: 'Pago',
  Recusado: 'Recusado',
}

// Estados finais de uma importação — o polling para ao atingir qualquer um deles.
export const STATUS_IMPORTACAO_FINAIS = [
  'Processado',
  'ProcessadoComFalhas',
  'Falha',
  'Cancelado',
]

export const isImportacaoEmAndamento = (status: string): boolean => status === 'Recebido' || status === 'EmProcessamento'

const STATUS_IMPORTACAO_CORES: { [key: string]: string } = {
  Recebido: 'blue',
  EmProcessamento: 'orange darken-1',
  Processado: 'green darken-1',
  ProcessadoComFalhas: 'deep-orange darken-1',
  Falha: 'red darken-1',
  Cancelado: 'grey darken-1',
}

const STATUS_IMPORTACAO_ITEM_CORES: { [key: string]: string } = {
  Pendente: 'grey darken-1',
  Valida: 'teal darken-1',
  Invalida: 'red darken-1',
  Importada: 'green darken-1',
  Duplicada: 'orange darken-1',
}

const STATUS_LIQUIDACAO_CORES: { [key: string]: string } = {
  Solicitado: 'blue',
  Pago: 'green darken-1',
  Recusado: 'red darken-1',
}

const buildOptions = (labels: { [key: string]: string }) => Object.keys(labels).map(key => ({ value: key, text: labels[key] }))

export const tipoImportacaoLabel = (value: string) => TIPO_IMPORTACAO_LABELS[value] || value
export const tipoArquivoLabel = (value: string) => TIPO_ARQUIVO_LABELS[value] || value
export const origemPagamentoLabel = (value: string) => ORIGEM_PAGAMENTO_LABELS[value] || value
export const statusImportacaoLabel = (value: string) => STATUS_IMPORTACAO_LABELS[value] || value
export const statusImportacaoItemLabel = (value: string) => STATUS_IMPORTACAO_ITEM_LABELS[value] || value
export const statusLiquidacaoLabel = (value: string) => STATUS_LIQUIDACAO_LABELS[value] || value

export const statusImportacaoCor = (value: string) => STATUS_IMPORTACAO_CORES[value] || 'grey'
export const statusImportacaoItemCor = (value: string) => STATUS_IMPORTACAO_ITEM_CORES[value] || 'grey'
export const statusLiquidacaoCor = (value: string) => STATUS_LIQUIDACAO_CORES[value] || 'grey'

export const STATUS_IMPORTACAO_OPTIONS = buildOptions(STATUS_IMPORTACAO_LABELS)
export const STATUS_IMPORTACAO_ITEM_OPTIONS = buildOptions(STATUS_IMPORTACAO_ITEM_LABELS)
export const STATUS_LIQUIDACAO_OPTIONS = buildOptions(STATUS_LIQUIDACAO_LABELS)
export const TIPO_IMPORTACAO_OPTIONS = buildOptions(TIPO_IMPORTACAO_LABELS)
